import React from "react";
import "../assets/titli/css/titli.css";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react"; // optional icon library


const Titli = () => {
    const navigate = useNavigate();
  return (
    <>
      <div className="ticket-container">
      <div className="header">
        <span className="title" onClick={() => navigate(-1)}><ArrowLeft /> {/* back icon */} Back</span>
        <span className="money">₹10000</span>
      </div>

        {/* Top Stamps */}
        <div className="stamps-row">
          <div className="stamp butterfly-stamp">
            <div className="stamp-content">🦋</div>
          </div>
          <div className="stamp empty-stamp">
            <div className="stamp-content">
              <div className="stars">
                <div className="star"></div>
                <div className="star"></div>
              </div>
            </div>
          </div>
          <div className="stamp empty-stamp">
            <div className="stamp-content">
              <div className="stars">
                <div className="star"></div>
                <div className="star"></div>
              </div>
            </div>
          </div>
        </div>

        {/* First Row of Icons */}
        <div className="icons-row first-row">
          <div className="icon umbrella">☔</div>
          <div className="icon soccer">⚽</div>
          <div className="icon sun">☀️</div>
          <div className="icon lamp">🪔</div>
          <div className="icon cow">🐄</div>
          <div className="icon bucket">🪣</div>
        </div>

        {/* Second Row of Icons */}
        <div className="icons-row second-row">
          <div className="icon kite">🪁</div>
          <div className="icon top">🪀</div>
          <div className="icon rose prize-icon">
            🌹
            {/* <span className="prize">16k</span> */}
          </div>
          <div className="icon butterfly">🦋</div>
          <div className="icon pigeon">🕊️</div>
          <div className="icon rabbit">🐰</div>
        </div>

        {/* Bottom Section */}
        <div className="bottom-section">
          <div className="portrait-container">
            <img
              src="/assets/images/coin.png"
              alt="coin"
              className="portrait"
            />
            <span className="bet_coin">10</span>
          </div>

          <div className="portrait-container">
            <img
              src="/assets/images/coin.png"
              alt="coin"
              className="portrait"
            />
            <span className="bet_coin">100</span>
          </div>

          <div className="portrait-container">
            <img
              src="/assets/images/coin.png"
              alt="coin"
              className="portrait"
            />
            <span className="bet_coin">500</span>
          </div>

          <div className="portrait-container">
            <img
              src="/assets/images/coin.png"
              alt="coin"
              className="portrait"
            />
            <span className="bet_coin">1K</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Titli;
